import { WidgetDataSource } from '../../../../../../../models';
import {
  Widget,
  WidgetGroup,
  Comparison,
  SectionFilter,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class VolumeOverTimePointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison,
    sectionFilter?: SectionFilter[]
  ): AiInsightPayloadParams {
    selectedPoints.sort((p1, p2) => p1.category - p2.category);

    return super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison,
      sectionFilter
    );
  }

  protected override fillWidgetQueryOptionsForPoint(widgetQueryOptions: any, point: any): void {
    super.fillWidgetQueryOptionsForPoint(widgetQueryOptions, point);

    widgetQueryOptions.widgetContextMenu.category = point.category;
    widgetQueryOptions.widgetContextMenu.series = point.series;
    widgetQueryOptions.widgetContextMenu.index = point.index;
  }
}
